export enum ApplicantType {
  Person = 0,
  Organization = 1,
}
